module.exports = __webpack_public_path__ + "static/media/golfer-2-a.9d11287d.png";